import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, MapPin, Building2 } from 'lucide-react';

const EventInfo = () => {
  // Variantes para el contenedor (maneja el retraso entre hijos)
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3, // Aparecen en orden: Fecha -> Modalidad -> Lugar
        delayChildren: 0.2
      }
    }
  };

  // Variantes para cada item individual
  const itemVariants = {
    hidden: { 
      y: 30, 
      opacity: 0 
    },
    visible: {
      y: 0,
      opacity: 1,
      transition: { 
        duration: 0.6, 
        ease: [0.215, 0.610, 0.355, 1.000] 
      }
    }
  };

  const infoItems = [
    {
      icon: <Calendar className="text-[#febe10]" size={32} />,
      title: "Fecha",
      text: "3 y 4 de septiembre de 2026"
    },
    {
      icon: <MapPin className="text-[#febe10]" size={32} />,
      title: "Modalidad",
      text: "Presencial"
    },
    {
      icon: <Building2 className="text-[#febe10]" size={32} />,
      title: "Lugar",
      text: "Centro de convenciones UTPL"
    }
  ];

  return (
    <section className="pt-4 bg-white overflow-hidden">
      <div className="max-w-6xl mx-auto px-6 pb-8">
        <motion.div 
          /* Responsive Grid: 1 columna en móvil, 3 columnas en tablets y escritorio */
          className="grid grid-cols-1 sm:grid-cols-3 gap-8"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
        >
          {infoItems.map((item, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              whileInView={{ 
                y: -5,
              duration: 0.2 ,
              }}
              /* Diseño vertical: flex-col e items-center */
              className="flex flex-col  items-center text-center gap-6 p-10 rounded-[3rem] bg-[#004270]/5 border border-slate-100 group transition-all duration-300 hover:bg-[#004270] hover:shadow-2xl hover:shadow-blue-900/20"
            >
              {/* Contenedor del Icono (Arriba) */}
              <div className="w-20 h-20 rounded-[1.5rem] bg-white shadow-md flex items-center justify-center flex-shrink-0 group-hover:rotate-12 transition-all duration-500">
                {item.icon}
              </div>

              {/* Contenedor de Texto (Abajo) */}
              <div className="space-y-2">
                <span className="block text-[11px] font-black uppercase tracking-[0.3em] text-[#004270]/50 group-hover:text-white/50 transition-colors">
                  {item.title}
                </span>
                <span className="block text-xl font-light text-[#004270] leading-snug group-hover:text-white transition-colors">
                  {item.text}
                </span>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default EventInfo;